import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ExportCsvSelectionDialogComponent } from './export-csv-selection-dialog/export-csv-selection-dialog.component';

@Component({
  selector: 'sales-ui-pipeline-export-csv',
  templateUrl: './pipeline-export-csv.component.html',
  styleUrls: ['./pipeline-export-csv.component.scss'],
})
export class PipelineExportCSVComponent {
  constructor(private readonly dialog: MatDialog) {}

  openCSVSelectionDialog(): void {
    this.dialog.open(ExportCsvSelectionDialogComponent, {
      width: '350px',
    });
  }
}
